export const RE_INITIALIZE_PRODUCT_SALES_STATISTICS_FILTER = 'RE_INITIALIZE_PRODUCT_SALES_STATISTICS_FILTER'
export const SET_PRODUCT_SALES_STATISTICS_FILTER = 'SET_PRODUCT_SALES_STATISTICS_FILTER'
export const SET_PRODUCT_SALES_STATISTICS_IS_LOADED = 'SET_PRODUCT_SALES_STATISTICS_IS_LOADED'
export const SET_PRODUCT_SALES_STATISTICS = 'SET_PRODUCT_SALES_STATISTICS'
export const APPEND_PRODUCT_SALES_STATISTICS = 'APPEND_PRODUCT_SALES_STATISTICS'
export const SET_PRODUCT_SALES_STATISTICS_TOTAL_LENGTH = 'SET_PRODUCT_SALES_STATISTICS_TOTAL_LENGTH'
export const SET_PRODUCT_SALES_STATISTICS_FILTER_READY = 'SET_PRODUCT_SALES_STATISTICS_FILTER_READY'
export const SET_PRODUCT_SALES_CATEGORIES = 'SET_PRODUCT_SALES_CATEGORIES'
